import { useLazyQuery } from '@apollo/client';
import useDashboardSelector from '../../../../../redux/selectorHooks/useDashboardSelector';
import {
  IDashboardFolderQuery,
  IDashboardFolderQueryVariables,
} from '../../../../../utils/apollo/graphqlSchema';
import { dashboardFolderQuery } from '../../../../../utils/apollo/dashboards';
import { useAppDispatch } from '../../../../../redux/hooks';
import { populatePublishedFolder } from '../../../../../redux/slices/dashboards/dashboardInstance';
import useDashboardTemplatesReloadEffect from '../../../utils/useDashboardTemplatesReloadEffect';

const useRefetchPublishedFolder = () => {
  const dispatch = useAppDispatch();

  const publishedFolder = useDashboardSelector('publishedFolder');

  const handleLoadFolder = ({ dashboardFolder }: IDashboardFolderQuery) => {
    dispatch(populatePublishedFolder({ publishedFolder: dashboardFolder }));
  };

  const [loadFolder] = useLazyQuery<
    IDashboardFolderQuery,
    IDashboardFolderQueryVariables
  >(dashboardFolderQuery, {
    variables: {
      id: publishedFolder?.id ?? null,
    },
    onCompleted: handleLoadFolder,
  });

  useDashboardTemplatesReloadEffect(loadFolder);
};

export default useRefetchPublishedFolder;
